import {BasicScenario} from '../../framework/parameters/BasicScenario';

export class BusinessUnitScenario extends BasicScenario {
manageCountries: boolean | null;
manageCurrencies: boolean | null;
manageHierarchy: boolean | null;
manageLanguages: boolean | null;
}

